import { addMonths, eachDayOfInterval, endOfMonth, endOfWeek, format, isSameMonth, isToday, startOfMonth, startOfWeek } from "date-fns";
import { ChevronLeft, ChevronRight } from "lucide-react";

const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export default function CalendarView({ month, onMonthChange, bookings, onBookingClick, onDayClick, canEdit }) {
  const start = startOfWeek(startOfMonth(month), { weekStartsOn: 1 });
  const end = endOfWeek(endOfMonth(month), { weekStartsOn: 1 });
  const days = eachDayOfInterval({ start, end });

  const byDate = {};
  bookings.forEach((b) => {
    (byDate[b.date] = byDate[b.date] || []).push(b);
  });

  return (
    <div className="card-brutal shadow-[6px_6px_0px_0px_#0f172a] p-4" data-testid="bookings-calendar">
      <div className="flex items-center justify-between mb-4">
        <button className="btn-secondary !px-2.5" onClick={() => onMonthChange(addMonths(month, -1))} data-testid="calendar-prev-month">
          <ChevronLeft className="w-4 h-4" />
        </button>
        <h2 className="font-display text-xl md:text-2xl uppercase text-slate-900" data-testid="calendar-month-title">
          {format(month, "MMMM yyyy")}
        </h2>
        <button className="btn-secondary !px-2.5" onClick={() => onMonthChange(addMonths(month, 1))} data-testid="calendar-next-month">
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>

      <div className="grid grid-cols-7 border-2 border-slate-900 bg-slate-900 gap-[2px]">
        {WEEKDAYS.map((d) => (
          <div key={d} className="bg-slate-900 text-white font-mono-tight uppercase text-xs p-2 text-center font-bold tracking-widest">
            {d}
          </div>
        ))}
        {days.map((day) => {
          const key = format(day, "yyyy-MM-dd");
          const dayBookings = byDate[key] || [];
          const inMonth = isSameMonth(day, month);
          return (
            <div
              key={key}
              onClick={() => onDayClick(key)}
              className={`min-h-[110px] p-2 flex flex-col transition-colors relative ${
                inMonth ? "bg-white" : "bg-slate-100 text-slate-400"
              } ${canEdit ? "cursor-pointer hover:bg-sky-50" : ""} ${isToday(day) ? "outline outline-4 outline-sky-400 -outline-offset-4" : ""}`}
              data-testid={`calendar-day-${key}`}
            >
              <div className={`font-mono-tight text-xs font-bold mb-1 ${isToday(day) ? "text-sky-600" : ""}`}>
                {format(day, "d")}
              </div>
              <div className="flex flex-col gap-1">
                {dayBookings.map((b) => (
                  <button
                    key={b.id}
                    onClick={(e) => { e.stopPropagation(); onBookingClick(b); }}
                    className={`text-left border-2 border-slate-900 p-1 text-[11px] font-bold tracking-tight shadow-[2px_2px_0px_0px_#0f172a] truncate transition-colors ${
                      b.rink === "clonmel" ? "bg-indigo-100 hover:bg-indigo-400 hover:text-white" : "bg-sky-100 hover:bg-sky-400 hover:text-white"
                    }`}
                    title={`${b.session_time} — ${b.group_name} (${b.number_attending})`}
                    data-testid={`calendar-booking-${b.id}`}
                  >
                    {b.session_time} {b.group_name}
                  </button>
                ))}
              </div>
            </div>
          );
        })}
      </div>
      {canEdit && (
        <p className="font-mono-tight text-[11px] uppercase tracking-widest text-slate-500 mt-3">
          Tip: click a day to add a booking
        </p>
      )}
    </div>
  );
}
